$(document).ready(function() {
  var ACTIVE_CLASS = 'navigation__content__links__first-level-list__item--active';
  var FOCUS_CLASS = 'navigation__content__links__first-level-list__item--focus';

  var $items = $('.navigation__content__links__first-level-list__item');
  
  var repositionCursor = function($element) {
    $('.navigation__content__cursor').css('left', $element.offset().left + $element.width() / 2 - $('.navigation__content').offset().left);
  };

  var resetCursor = function() {
    if ($('.' + ACTIVE_CLASS).size()) {
      repositionCursor($('.' + ACTIVE_CLASS));
    } else {
      repositionCursor($('.navigation__content__logo'));
    }
  };

  var adjustNavigationImage = function() {
    $('.navigation__content__background__image').height($('.page-cover').outerHeight());
  };

  var toggleNavigationSize = function() {
    $('.navigation').toggleClass('navigation--mini', $(window).scrollTop() > 0);

    setTimeout(resetCursor, 1000);
  };

  setTimeout(resetCursor, 100);

  setTimeout(function() {
    $('.navigation__content__cursor').addClass('navigation__content__cursor--animatable');
  }, 110);

  $items.hover(function() {
      var $target = $(this);
      $target.addClass(FOCUS_CLASS);
      repositionCursor($target);
    }, function() {
      var $target = $(this);
      
      $target.removeClass(FOCUS_CLASS);

      setTimeout(function() {
        if (!$items.hasClass(FOCUS_CLASS)) {
          resetCursor();
        }
      }, 250);
    });

  $(document).click(function($event) {
    if (!$($event.target).closest('.' + FOCUS_CLASS).size()) {
      $items.removeClass(FOCUS_CLASS);
      resetCursor();
    }
  });
  
  adjustNavigationImage();
  toggleNavigationSize();

  $(window).on('load', adjustNavigationImage);
  $(window).on('resize', _.debounce(adjustNavigationImage, 100));
  $(window).on('scroll', _.throttle(toggleNavigationSize, 100));

  $('.navigation__content__toggle').on('click', function($event) {
    $event.preventDefault();

    $('body').toggleClass('prevent-scroll');
    $('.navigation').toggleClass('navigation--open');
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/navigation.js
 ** module id = 1
 ** module chunks = 0
 **/